import _ from "lodash";
import i18n from "i18next";

let UserLanguageService = {

    supportedLanguages: ['en-US', 'pt-PT', 'es-ES', 'fr-FR', 'de-DE'],

    defaultLanguage: 'en-US',

    currentLanguage: 'en-US',

    isLanguageSupported: function (language) {
        return _.includes(UserLanguageService.supportedLanguages, language);
    },

    getBrowserLanguage: function () {
        return i18n.language || (typeof window !== 'undefined' && window.localStorage.i18nextLng) || UserLanguageService.defaultLanguage;
    },

    getCurrentLanguage: function () {
        return this.currentLanguage;
    },

    setDefaultLanguage: function () {
        let browserLanguage = UserLanguageService.getBrowserLanguage();
        UserLanguageService.setUserLanguage(browserLanguage);
        i18n.changeLanguage(browserLanguage);
    },

    setUserLanguage: function (language) {
        if(_.isNil(language)) {
            UserLanguageService.setDefaultLanguage();
        } else {
            language = language.indexOf('_') !== -1? _.replace(language,'_', '-') : language;
            if(UserLanguageService.isLanguageSupported(language)) {
                this.currentLanguage = language;
                i18n.changeLanguage(language);
            } else {
                UserLanguageService.setDefaultLanguage();
            }
        }
    }
};

export default UserLanguageService;